/**
 * GeChiUI dependencies
 */
import { useEffect } from '@gechiui/element';
import deprecated from '@gechiui/deprecated';

export default function GuidePage( props ) {
	useEffect( () => {
		deprecated( '<GuidePage>', {
			since: '5.5',
			alternative: 'the `pages` prop in <Guide>',
		} );
	}, [] );

	return <div { ...props } />;
}
